<!-- eslint-disable -->
<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { closeModal, confirmModal } from '@kolirt/vue-modal'
import { useGeneralStore } from '@/stores/general';
import { BetSlip } from '@/stores/BetSlip';
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import ShareBetBetslip from './ShareBetBetslip.vue';
import SharebetReciept from './SharebetReciept.vue';
import html2canvas from 'html2canvas';
import Socials from '@/components/Common/Socials.vue'

const { t } = useI18n();
const generalStore = useGeneralStore();
const betslipStore = BetSlip();
const svg_data = ref(commonSvgs);
const share_url_text = ref(t('general.copy_url'));
const share_id_text = ref(t('general.copy_code'));
const loading = ref(false);
const show_prices = ref(true);
const modalContent = ref(null);

const props = defineProps({
	share_url: {
		type: String,
		required: true
	},
	share_id: {
		type: String,
		required: true
	},
	is_placed: {
		type: Boolean,
		required: false,
		default: false
	},
	betslip: {
		type: Object,
		required: false,
		default: null,
	}
});

const copy_link = ref(false);
const copyToClipboard = () => {
	navigator.clipboard.writeText(props.share_url);
	share_url_text.value = t('general.copied')
	copy_link.value = true;
	setTimeout(() => {
		share_url_text.value = t('general.copy_url');
		copy_link.value = false;
	}, 2000);
}

const copy_id = ref(false);
const copyIdToClipboard = () => {
	navigator.clipboard.writeText(props.share_id);
	share_id_text.value = t('general.copied')
	copy_id.value = true;
	setTimeout(() => {
		share_id_text.value = t('general.copy_code');
		copy_id.value = false
	}, 2000);
}

const downloadBetslip = async () => {
	if (!modalContent.value) return;
	loading.value = true;

	// 1. Clone off-screen
	const clone = modalContent.value.cloneNode(true);
	clone.style.position = 'absolute';
	clone.style.left = '-9999px';
	clone.style.top = '0';
	clone.style.width = '600px';
	document.body.appendChild(clone);

	try {
		// 2. Fix SVGs
		const useTags = clone.querySelectorAll('use');
		const svgCache = {};

		for (const useTag of useTags) {
			const href = useTag.getAttribute('xlink:href') || useTag.getAttribute('href');
			if (!href) continue;

			const [url, id] = href.split('#');

			if (url && id) {
				if (!svgCache[url]) {
					try {
						const res = await fetch(url);
						const text = await res.text();
						svgCache[url] = new DOMParser().parseFromString(text, 'image/svg+xml');
					} catch (e) {
						console.error('Fetch error:', e);
						continue;
					}
				}

				const doc = svgCache[url];
				const symbol = doc.getElementById(id);

				if (symbol) {
					const parentSvg = useTag.closest('svg');

					if (symbol.hasAttribute('viewBox')) parentSvg.setAttribute('viewBox', symbol.getAttribute('viewBox'));

					Array.from(symbol.children).forEach(child => {
						parentSvg.appendChild(child.cloneNode(true));
					});

					useTag.remove();
				}
			}
		}

		// 3. Layout adjustments
		const container = clone.querySelector('.betslip-container');
		if (container) {
			container.style.maxHeight = 'none';
			container.style.overflow = 'visible';
			container.style.height = 'auto';
		}

		const wrapper = clone.querySelector('.share-modal-inner');
		if(wrapper) {
			wrapper.style.height = 'auto';
			wrapper.style.maxHeight = 'none';
		}

		// 4. Capture
		const canvas = await html2canvas(clone, {
			useCORS: true,
			scale: 3,
			backgroundColor: null,
		});

		const link = document.createElement('a');
		link.download = `${generalStore.getSiteName}-${props.share_id || 'shared'}.png`;
		link.href = canvas.toDataURL('image/png');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

	} catch (error) {
		console.error('Error:', error);
	} finally {
		document.body.removeChild(clone);
		loading.value = false;
	}
};



const calculateBetslipLabel = computed(() => {
	if (props.betslip?.betslip_type_lang) return props.betslip.betslip_type_lang;
	if (betslipStore.betslip.type == 'singles' || betslipStore.betslip.type == 'single') return t('betslip.single');
	if (betslipStore.betslip.type == 'multiple') return t('betslip.multiple');
	if (betslipStore.countBetslipBets > 2 && betslipStore.betslip.type == 'system') return t('betslip.system');
	return '';
});

</script>
<template name="ShareBetModal" class="ShareBetModal">
	<section class="share-modal-main">
		<div class="share-modal-inner">
			<span class="form-cross">
				<a @click="closeModal" class="close-btn-wrapper">
					<span v-html="svg_data.form_cross" class="svg-icon"></span>
				</a>
			</span>

			<div class="header-info">
				<div class="code-title">
					<h5>{{ t('share_bet.your_booking_code')}}</h5>
				</div>

				<div class="card">
					<div class="row">
						<span class="text">{{ share_id }}</span>
						<button class="icon-btn" @click="copyIdToClipboard()">
							<div v-if="copy_id">
								<i class="fa fa-check" style="color: var(--primary);"></i>
							</div>
							<div v-else>
								<i class="fa fa-clone" style="color: var(--white);"></i>
							</div>
						</button>
					</div>

					<div class="xd">
						<div class="link-box">
							<span class="left-icon">

								<svg  style="width:15px; height:15px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" svg-inline="" title="Toggle" role="presentation" focusable="false" xmlns:xlink="http://www.w3.org/1999/xlink" class="markets-toggle-svg">
									<use xlink:href="/assets/icons/link-icon.svg#Layer_1" style="fill: var(--tab-gray);"></use>
								</svg>
							</span>

							<span class="link-text">
								{{ share_url }}
							</span>
						</div>
						<button class="right-icon" @click="copyToClipboard()">
							<div v-if="copy_link">
								<i class="fa fa-check" style="color: var(--primary);"></i>
							</div>
							<div v-else>
								<i class="fa fa-clone" style="color: var(--white);"></i>
							</div>
						</button>
					</div>
				</div>
			</div>

			<div v-if="props.is_placed" class="sub-title">
				<h5>{{ $t('general.show_prices')}}</h5>
				<div class="switch-outer">
					<div v-if="show_prices">
						<i class="fa fa-eye eye-icon-class"></i>
					</div>
					<div v-else>
						<i class="fa fa-eye-slash eye-icon-class"></i>
					</div>
					<label class="switch">
						<input :checked="show_prices" @change="show_prices = !show_prices" type="checkbox">
						<span class="switch-slider round"></span>
					</label>
				</div>
			</div>

			<div ref="modalContent">
				<div class="betslip-container">
					<div class="betslip-header">
						<img class="logo-img" :src="generalStore.getGeneral.header_logo" alt="logo-desktop">
						<span>{{ calculateBetslipLabel }}</span>
					</div>

					<div class="betslip-body">
						<ShareBetBetslip :betslip="props.betslip" />

						<SharebetReciept v-if="props.is_placed && show_prices" :betslip="props.betslip"/>
					</div>
				</div>
			</div>

			<div class="footer">
				<div class="row">
					<Socials :text="t('share_bet.share_text')" :url="share_url"/>

					<button v-if="loading" class="btn-small btn-secondary ShareBtns disabled-btn" type="button">
						<div class="loader-main"></div>
					</button>

					<button v-else @click="downloadBetslip" class="btn-small btn-secondary ShareBtns" type="button">
						{{ t('message.download') }}
						<i class="fa fa-image"></i>
					</button>
				</div>
			</div>


		</div>
	</section>

</template>
<style scoped>
.row .accu {
	color: var(--white)
}

.row .price {
	color: var(--primary)
}

.row .price span {

    color: var(--white);

}
.xd {
	display: flex;
}
.link-box {
    max-width: 90%;
    display: flex;
    align-items: center;
    background: var(--light-dark);
    padding: 10px 8px;
    border-radius: 6px;
    color: #9ca3af;
}

.left-icon,
.right-icon {
    display: flex;
    align-items: center;
    color: #9ca3af;
}

.left-icon {
	margin-right: 3px;

}

.right-icon {
    margin-left: auto;
    background: transparent;
    border: none;
    cursor: pointer;
}

.right-icon:hover {
    color: var(--white);
}

.link-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
}

.card {
    padding: 20px;
    /* border-radius: 8px; */
    color: #fff;
	border-bottom: 1px solid var(--tab-gray);
}

.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.input-row {
    background: #1f2937;
    padding: 10px 12px;
    border-radius: 6px;
}

.text {
    font-size: 16px;
    font-weight: 600;
}

.link {
    font-weight: 400;
    font-size: 14px;
    color: #9ca3af;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 420px;
}

.icon-btn {
    background: transparent;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.icon-btn:hover {
    color: var(--white);
}

.code-title {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--tab-gray);
    color: var(--white);
	font-size: 20px;
}

.code-title h5 {
  padding-left: 4%;
  padding-right: 4%;
	font-size: 22px;
}

.share-modal-main .share-modal-inner {
	padding: 0;
}

.share-modal-main .share-modal-inner .title {
	padding: 4% 4% 2% 4%;
	/* border-bottom: 1px solid var(--dark); */
}

.share-modal-main .share-modal-inner .title h5 {
	font-size: 20px;
	text-align: start;
	padding-bottom: 0px;
}

.betslip-container {
	border-bottom: 1px solid var(--light-dark);
	padding: 4%;
	max-height: 350px;
	overflow: hidden;
	overflow-y: auto;
	background: linear-gradient(to bottom right, var(--dark) 50%, var(--primary) 140%);
}

.betslip-header {
	display: flex;
	justify-content: space-between;
}

.betslip-header h5 {
	color: var(--text-secondary-color);
	font-size: 16px;
	text-align: start;
}

.betslip-header span {
	font-size: 10px;
	text-align: end;
	color: var(--dark);
	background: var(--secondary);
	padding: 5px;
	border-radius: 4px;
	font-weight: 500;
	cursor: default;
}

.footer {
	padding: 4%;
	display: grid;
	/* flex-wrap: wrap;
	align-content: center;
	align-items: center;
	justify-content: space-evenly; */
}

.footer .footer-right {
	flex: 1;
	text-align: end;
}

.footer .footer-left {
	flex: 2;
	text-align: start;
	display: flex;
	align-content: center;
	align-items: center;
	gap: 3%;
	flex-direction: column;
	row-gap: 4px;
}

.footer-left-btns {
	display: flex;
	align-content: center;
	align-items: center;
	justify-content: center;
	gap: 3%;
	width: 100%;
}

.fieldset {
	position: relative;
	margin-bottom: 0;
	border: 1px solid var(--tab-gray);
	overflow-x: auto;
	border-radius: 3px;
	background: var(--dark-gray);
	padding: 2px 10px;
	height: 36px;
	width: 65%;
}

.fieldset p {
	width: -moz-max-content;
	width: max-content;
	color: var(--primary);
	padding: 0;
	font-size: 16px;
	font-weight: 500;
	text-align: start;
	display: flex;
	align-items: center;
	height: 100%;
}

.ShareBtns {
	width: 110px;
}

.disabled-btn {
	cursor: default;
	display: flex;
	justify-content: center;
	border: 1px solid var(--light-gray);
	background: var(--dark);
	color: var(--white);
}

.form-cross {
	position: absolute;
	top: -12px;
	right: -12px;
	z-index: 100;
}

.close-btn-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;

	background-color: var(--dark);
	border: 1px solid var(--dark);
	border-radius: 50%;

	cursor: pointer;
	box-shadow: 0 4px 10px var(--dark);
	transition: all 0.2s ease;
}

.close-btn-wrapper:hover {
	background-color: var(--light-dark);
	transform: scale(1.05);
}

.svg-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 0;
}

.svg-icon :deep(svg) {
	width: 12px;
	height: 12px;
	fill: var(--white) !important;
	stroke: var(--white) !important;
}

.share-modal-inner {
	position: relative;
	overflow: visible !important;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.btn-small {
		font-size: 12px;
	}

	.footer {
		row-gap: 6px;
	}
}

.sub-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 4% 2% 4%;
	border-bottom: 1px solid var(--dark);
}

.sub-title h5 {
	font-size: 13px;
	text-align: start;
	padding-bottom: 0px;
	color: var(--light-gray);
	font-weight: 500;
}

.switch-outer {
	display: flex;
	align-items: center;
}

.eye-icon-class {
	margin-right: 10px;
	color: var(--light-gray);
	width: 1em;
}

html[dir="rtl"] .eye-icon-class {
	margin-right: 0;
	margin-left: 10px;
}

html[dir="rtl"] .right-icon {
	margin-right: 10px;
}

.logo-img {
	max-height: 25px;
}


@media screen and (min-width: 320px) and (max-width: 767px) {
    .share-modal-main {
        width: 95%;
    }

	.logo-img {
		max-height: 20px;
	}

	.code-title h5 {
		font-size: 18px;
	}

	.link-text {
		font-size: 11px;
	}
}

</style>